import { useNavigate } from 'react-router-dom';
import cns from 'classnames';
import pageData from '../../../common/talents/data.json';
import styles from './index.module.less';

function TalentPC() {
  const renderBrief = () => (
    <div className={styles.brief}>
      <img src={pageData.brief.imgList[0]} alt="" className={styles.brief__img} />
      <div className={styles.content}>{pageData.brief.content}</div>
      <img src={pageData.brief.imgList[1]} alt="" className={styles.brief__img} />
    </div>
  );

  const classItem = (item: any) => (
    <div key={item.title} className={styles.class__item}>
      <div className={styles['tertiary-title']}>{item.title}</div>
      {item.imgUrl && <img src={item.imgUrl} className={styles.class__img} alt="" />}
      <div className={cns(styles.content, styles.class__content)}>{item.content}</div>
    </div>
  );

  const renderElementClass = () => (
    <div className={styles.class}>
      <div className={styles.subtitle}>{pageData.elementClass.label}</div>
      {pageData.elementClass.value.map((item) => classItem(item))}
    </div>
  );
  const renderEconomicsClass = () => (
    <div className={styles.class}>
      <div className={styles.subtitle}>{pageData.economicsClass.label}</div>
      {pageData.economicsClass.value.map((item) => classItem(item))}
    </div>
  );

  return (
    <section className={styles.local}>
      <div className={styles.local__container}>
        {renderBrief()}
        {renderElementClass()}
        {renderEconomicsClass()}
      </div>
    </section>
  );
}

export default TalentPC;
